var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-block" }, [
    _vm.marker
      ? _c(
          "div",
          {
            class: {
              "ribbon ribbon-top-right": true,
              c_orange: _vm.marker.color === 1,
              c_blue: _vm.marker.color === 2,
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.marker.text))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("p", [
          _vm._v("Заявка: "),
          _c("strong", [_vm._v(_vm._s((_vm.order.id + "").substr(-4)))]),
          _vm._v(
            "\n      (" +
              _vm._s(
                _vm.$AllProjects[_vm.order.site_id] &&
                  _vm.$AllProjects[_vm.order.site_id].name
              ) +
              ")\n      "
          ),
          _vm.isNoReply()
            ? _c("span", { staticClass: "badge badge-warning" }, [
                _vm._v("недозвон"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "float-right badge badge-dark",
              staticStyle: { "font-size": "27px" },
            },
            [_vm._v(_vm._s(_vm.order.line_order))]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Клиент:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.order.client_name ||
                  (_vm.order.client && _vm.order.client.name)
              )
          ),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Телефоны:")]),
        _vm._v(" "),
        _vm._l(_vm.order.order_phones, function (phone) {
          return phone.phone
            ? _c("div", { staticClass: "phone_div" }, [
                _c("p", [
                  _c("a", { attrs: { href: `tel:${phone.phone.phone}` } }, [
                    _vm._v(
                      _vm._s(_vm.mixinPrintPhone("00" + phone.phone.phone))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                phone.phone && phone.phone.comment
                  ? _c("p", [_vm._v(_vm._s(phone.phone.comment))])
                  : _vm._e(),
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "fs-18" }, [
          _c("strong", [_vm._v(_vm._s(_vm.order.address))]),
        ]),
        _vm._v(" "),
        _vm.order.extra_options.address_details
          ? _c("p", [_vm._v(_vm._s(_vm.order.extra_options.address_details))])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.metro_station && _vm.order.metro_station.line
          ? [
              _c("p", { staticClass: "metro_line" }, [
                _c(
                  "span",
                  {
                    staticClass: "badge fs-18",
                    style: {
                      backgroundColor: _vm.order.metro_station.line.color,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.order.metro_station.line.number))]
                ),
                _vm._v(
                  " " + _vm._s(_vm.order.metro_station.line.title) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("i", { staticClass: "icon-fa icon-fa-subway fs-18" }),
                _vm._v(" " + _vm._s(_vm.order.metro_station.title)),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "table_block" }, [
      _c("table", { staticClass: "table table-sm" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.order.details, function (detail) {
            return _c("tr", [
              _c("td", [
                detail.new_drug.cool
                  ? _c("i", { staticClass: "icon icon-snowflake" })
                  : _vm._e(),
                _vm._v(" " + _vm._s(detail.new_drug.title) + "\n          "),
                (detail?.extra_data?.comments ?? []).length
                  ? _c(
                      "div",
                      { staticClass: "alert alert-info p-1" },
                      _vm._l(detail.extra_data.comments, function (comment) {
                        return _c("p", [_vm._v(_vm._s(comment.text))])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p"),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(detail.qty))]),
              _vm._v(" "),
              _c("td", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(detail?.currency_price ?? detail.price)),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.marker
            ? _c("div", { staticClass: "alert alert-danger" }, [_vm._m(2)])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.extra_options.runner_comments &&
          _vm.order.extra_options.runner_comments.length
            ? [
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v("Мои комментарии"),
                ]),
                _vm._v(" "),
                _vm._l(
                  _vm.order.extra_options.runner_comments,
                  function (comment) {
                    return _c("div", { staticClass: "comment_block" }, [
                      _c("div", {
                        staticClass: "mb-0",
                        domProps: { innerHTML: _vm._s(comment.message) },
                      }),
                      _vm._v(" "),
                      comment.created_at
                        ? _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              _vm._s(_vm.moment(comment.created_at, "HH:mm"))
                            ),
                          ])
                        : _vm._e(),
                    ])
                  }
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-content-between" }, [
      _c(
        "div",
        { staticClass: "mt-1" },
        [
          _c("UploadFile", {
            attrs: { "order-id": _vm.order.id, type: "runnersFile" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-1" },
            [_c("FastCallBackRequest", { attrs: { order: _vm.order } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("p", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.printDate(_vm.order.delivery_date, "DD.MM.YYYY"))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("доставка: "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.order.currency_delivery ?? _vm.order.delivery_price ?? 0
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("скидка: "),
            _c("strong", [_vm._v(_vm._s(_vm.order.discount || 0))]),
          ]),
          _vm._v(" "),
          +_vm.order.pay_method === 3
            ? [
                _c("p", [
                  _vm._v("к оплате наличными "),
                  _c("strong", { staticClass: "badge badge-info fs-18" }, [
                    _vm._v(_vm._s(_vm.order.price - _vm.order.no_cash_price)),
                  ]),
                  _vm._v("\n          руб"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("(предоплата "),
                  _c("strong", { staticClass: "badge badge-info fs-18" }, [
                    _vm._v(_vm._s(_vm.order.no_cash_price)),
                  ]),
                  _vm._v(" руб, получена)"),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          +_vm.order.pay_method !== 3 && _vm.order.credit_card_id
            ? [
                _c("p", [
                  _vm._v("к оплате наличными "),
                  _c("strong", { staticClass: "badge badge-info fs-18" }, [
                    _vm._v(_vm._s(_vm.order.price)),
                  ]),
                  _vm._v("\n          руб"),
                ]),
                _vm._v(" "),
                _vm.order.credit_card
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _c("p", [_vm._v("Карта для оплаты")]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.order.extra_options.card_number)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Получатель")]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.order?.credit_card?.owner?.full_name)
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.smsPayment && _vm.smsPayment.length
                  ? _c(
                      "div",
                      { staticClass: "alert alert-success" },
                      [
                        _c("p", [_vm._v("Найдены СМС с зачислением средств")]),
                        _vm._v(" "),
                        _vm._l(_vm.smsPayment, function (sms) {
                          return _c("p", [
                            _c(
                              "strong",
                              [
                                _vm._v(
                                  _vm._s(_vm.printDate(sms.date)) +
                                    " " +
                                    _vm._s(sms.message) +
                                    "\n            "
                                ),
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Подтвердить оплату",
                                    loading: _vm.loadingBtn,
                                    color: "white",
                                    onClick: () => _vm.confirmPayment(sms),
                                    className: "btn btn-success btn-xs",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-warning" }, [
                  _c("p", [
                    _vm._v(
                      "Клиент сообщил о намерении сделать предоплату на карту в размере\n            "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.order.no_cash_price))]),
                    _vm._v(
                      " руб, тогда сумма к оплате наличными будет\n            "
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.order.price - _vm.order.no_cash_price)),
                    ]),
                    _vm._v(" руб."),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Но предоплата ЕЩЕ НЕ получена. Нельзя доставлять эту заявку БЕЗ получения наличных и без подтверждения\n            предоплаты на карту"
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c(
                "div",
                { staticClass: "flex justify-content-between mb-2" },
                [
                  +_vm.order.pay_method === 1 && !_vm.order.credit_card_id
                    ? [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Получить реквизиты для оплаты по карте",
                            type: "button",
                            loading: _vm.loadingRequestBtn[_vm.order.id],
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.requestNoCashPayment(_vm.order),
                            className: "btn btn-outline-success btn-xs",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      +_vm.order.pay_method !== 3 && _vm.order.credit_card_id
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Запросить обновление оплаты",
                              type: "button",
                              loading: _vm.loadingRequestBtn[_vm.order.id],
                              color: _vm.$constants.SUCCESS_COLOR,
                              onClick: () => _vm.requestPaimentCheck(_vm.order),
                              className: "btn btn-outline-success btn-xs",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Обновить статус заявки",
                      type: "button",
                      loading: _vm.loadingBtn,
                      color: _vm.$constants.PRIMARY_COLOR,
                      onClick: () => {
                        _vm.reloadOrder()
                      },
                      className: "btn btn-outline-info btn-xs",
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-content-between" }, [
      _vm.$currentUID === 257
        ? _c(
            "div",
            [_c("PayByCrypto", { attrs: { orderId: _vm.order.id } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v("итого: "),
        _c("strong", { staticClass: "badge badge-info fs-18" }, [
          _vm._v(_vm._s(_vm.order.currency_id_price ?? _vm.order.price)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-content-between" }, [
      _c("div", [
        _c("p", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openMessages("comments")
                },
              },
            },
            [
              _vm._v(
                "Комментарии офис\n        (" +
                  _vm._s(
                    (_vm.order.extra_options.comments_for_runner &&
                      _vm.order.extra_options.comments_for_runner.length) ||
                      0
                  ) +
                  ")"
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.order.messages && _vm.order.messages.length
        ? _c("div", [
            _c("p", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openMessages("messages")
                    },
                  },
                },
                [_vm._v("Диалоги (" + _vm._s(_vm.order.messages.length) + ")")]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showComments
      ? _c(
          "div",
          { staticClass: "all_questions question" },
          _vm._l(
            _vm.order.extra_options.comments_for_runner,
            function (comment) {
              return _c("div", [
                _c("p", [_vm._v(_vm._s(comment.text))]),
                _vm._v(" "),
                _c("p", { staticClass: "text-right text-muted" }, [
                  _vm._v(_vm._s(_vm.moment(comment.created_at, "DD.MM HH:mm"))),
                ]),
              ])
            }
          ),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showMessages
      ? _c(
          "div",
          { staticClass: "all_questions" },
          _vm._l(_vm.order.messages || [], function (message) {
            return _c(
              "div",
              { staticClass: "question" },
              [
                _c("p", [
                  _c("i", {
                    class: {
                      "icon-fa": true,
                      "icon-fa-arrow-circle-left blue":
                        _vm.$currentUID === message.to_user_id,
                      "icon-fa-arrow-circle-right green":
                        _vm.$currentUID === message.user_id,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { domProps: { innerHTML: _vm._s(message.text) } }),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-right text-muted" }, [
                  _vm._v(_vm._s(_vm.moment(message.created_at, "DD.MM HH:mm"))),
                ]),
                _vm._v(" "),
                _vm._l(message.answers, function (answer) {
                  return _c("div", [
                    _c("p", [
                      _c("i", {
                        class: {
                          "icon-fa": true,
                          "icon-fa-arrow-circle-left blue":
                            _vm.$currentUID === answer.to_user_id,
                          "icon-fa-arrow-circle-right green":
                            _vm.$currentUID === answer.user_id,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(answer.text) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-right text-muted" }, [
                      _vm._v(
                        _vm._s(_vm.moment(answer.created_at, "DD.MM HH:mm"))
                      ),
                    ]),
                  ])
                }),
              ],
              2
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Адрес:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Стоимость")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Выдать в пакете с визиткой "),
      _c("strong", [_vm._v("Фарма-Логист")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }